<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Kidney Specific Details EMR-Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="stagedKidney"
              disabled
              label="Staged Kidney"
            />
          </div>
        </div>
    

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="kidneyPairedDonation"
              disabled
              label="Kidney Paired Donations"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="preEmptive"
              disabled
              label="Pre-Emptive"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="listExchange"
              disabled
              label="List Exchange"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="listExchangeDate"
              disabled
              label="List Exchange Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="previousLivingDonor"
              disabled
              label="Previous Living Donor"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="serumCreatinine"
              disabled
              label="Serum Creatinine"
            />
          </div>
        </div>

        <div class="row">  
          <div class="col-2">
            <ADSTextInput
              v-model="serumCreatinineDate"
              disabled
              label="Serum Creatinine Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="egfr"
              disabled
              label="EGFR"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="egfrDate"
              disabled
              label="EGFR Date"
            />
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="a1c"
              disabled
              label="A1C"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="a1cDate"
              disabled
              label="A1C Date"
            />
          </div>
        </div> -->

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="generalComments"
              disabled
              label="General Comments"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "KidneySpecificSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      stagedKidney: this.getStagedKidney( this.patientBundle ),
      kidneyPairedDonation: this.getKidneyPairedDonation( this.patientBundle ),
      preEmptive: this.getPreEmptive( this.patientBundle ),
      listExchange: this.getListExchange( this.patientBundle ),
      listExchangeDate: this.getListExchangeDate( this.patientBundle ),
      previousLivingDonor: this.getPreviousLivingDonor( this.patientBundle ),
      serumCreatinine: this.getSerumCreatinine( this.patientBundle ),
      serumCreatinineDate: this.getSerumCreatinineDate( this.patientBundle ),
      egfr: this.getEGFR( this.patientBundle ),
      egfrDate: this.getEGFRDate( this.patientBundle ),
      a1c: this.getA1C( this.patientBundle ),
      a1cDate: this.getA1CDate( this.patientBundle ),
      generalComments: this.getGeneralComments( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataValue( patientBundle, observationCode ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return;
      }
      const match = group.filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === observationCode &&
      _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
      if( !match[0] ) {
        return;
      }
      const component = _.get( match[0], 'resource.component[0]' );
      if( !component ) {
        return;
      }
      if( _.has( component, 'valueBoolean' ) ) {
        return component.valueBoolean ? 'Checked' : 'Unchecked';
      }
      if( component.valueString != null ) {
        return component.valueString;
      }
      if( component.valueDateTime != null ) {
        return component.valueDateTime;
      }
    },
    getStagedKidney( patientBundle ) {
      return this.getSmartdataValue( patientBundle, 'SK#8046' );
    },
    getKidneyPairedDonation( patientBundle ) {
      return this.getSmartdataValue( patientBundle, 'SK#8047' );
    },
    getPreEmptive( patientBundle ) {
      return this.getSmartdataValue( patientBundle, 'SK#8052' );
    },
    getListExchange( patientBundle ) {
      return this.getSmartdataValue( patientBundle, 'SK#8048' );
    },
    getListExchangeDate( patientBundle ) {
      return this.getSmartdataValue( patientBundle, 'SK#8049' );
    },
    getPreviousLivingDonor( patientBundle ) {
      return this.getSmartdataValue( patientBundle, 'SK#8050' );
    },
    getSerumCreatinine( patientBundle ) {
      return this.getSmartdataValue( patientBundle, 'SK#8284' );
    },
    getSerumCreatinineDate( patientBundle ) {
      return this.getSmartdataValue( patientBundle, 'SK#8422' );
    },
    getEGFR( patientBundle ) {
      return this.getSmartdataValue( patientBundle, 'SK#8062' );
    },
    getEGFRDate( patientBundle ) {
      return this.getSmartdataValue( patientBundle, 'SK#8063' );
    },
    getA1C( patientBundle ) {
      return this.getSmartdataValue( patientBundle, 'SK#8064' );
    },
    getA1CDate( patientBundle ) {
      return this.getSmartdataValue( patientBundle, 'SK#8065' );
    },
    getGeneralComments( patientBundle ) {
      return this.getSmartdataValue( patientBundle, 'SK#8066' );
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 1400px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

</style>
